import restApi from "@plannel/services/utils/rest-api";

/*
 * Sales Plan Dashboard 데이터 서비스.
 * 독립 DW(z_fact_dp_demand) + 결재 운영 테이블(z_postn*) 기반 백엔드 조회.
 *   백엔드: GET /api/dashboard-dw/sales-plan (SalesPlanDashboardController)
 * 응답: { period:{from,to,bucketUnit}, currencyCd, planVersion:{}, progress:{enabled,steps[]},
 *         planStatus:[{name,planQty,planAmt,actualQty,actualAmt,achieveQtyPct,achieveAmtPct}],
 *         forecastPlan:[{name,bfQty,sfQty,sfAmt,mfQty,mfAmt,interventionPct}],
 *         distribution:{item[],customer[],itemLevels[],custLevels[],itemLevel,custLevel} }
 * 참고: saas-application/docs/sql/dw/dashboard-spec/06_sales_plan.md
 */
const get = (params) => restApi.get("/api/dashboard-dw/sales-plan", { params });

const salesPlanService = { get };

export default salesPlanService;
